<template>
    <div class="redirect-page">
        <span>跳转中...</span>
    </div>
</template>
<script>
import { accessAPI } from '../../api/modules/accessAPI'
import { actions } from '../actions'
import { Store } from '../../server/utils/LocalCache'

export default {
    data() {
        return {
            token: "",
            area: "", // 地区
            menu: "", // 跳转到的地址
        }
    },
    mounted() {
        this.token = this.$route.query.token;
        this.area = this.$route.query.area;
        this.menu = this.$route.query.menu;

        // 石景山地区
        if(this.area == "sjs") {
            if(this.menu == "apps/report/confirm-declara" || this.menu == "apps/report/intermediary") { // 高企申报页面、中介机构查询页面
                accessAPI.getTripartiteEnterpriseInfo({ token: this.token }).then(res=>{
                    if(res.code == 200) {
                        actions.setGlobalState({token: res.data.access_token});
                        this.$store.commit('login/setLoginInfo', {
                            access_token: res.data.access_token,
                            refresh_token: res.data.refresh_token,
                            expires_in: res.data.expires_in,
                            userInfo: res.data
                        });
                        this.getAuthCompanyCode();

                        if(this.$route.query.show == "true") {
                            Store.put("hideLayout", null);
                        } else if(this.$route.query.show == "false") {
                            Store.put("hideLayout", false);
                        } else {
                            Store.put("hideLayout", null);
                        }

                        this.$router.push(this.menu);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            } else { // 科委用户 审核工作页
                accessAPI.getTripartiteExamine({ token: this.token }).then(res=>{
                    if(res.code == 200) {
                        actions.setGlobalState({token: res.data.access_token});
                        this.$store.commit('login/setLoginInfo', {
                            access_token: res.data.access_token,
                            refresh_token: res.data.refresh_token,
                            expires_in: res.data.expires_in,
                            userInfo: res.data
                        });

                        if(this.$route.query.show == "true") {
                            Store.put("hideLayout", null);
                        } else if(this.$route.query.show == "false") {
                            Store.put("hideLayout", false);
                        } else {
                            Store.put("hideLayout", null);
                        }

                        this.$router.push(this.menu);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    },
    methods: {
        // 登录成功获取企业用户标识信息
        getAuthCompanyCode() {
            this.$store.dispatch('login/getCompanyInfo').catch(error => {
                this.$message.error(error);
            })
        }
    }
}
</script>
<style lang="less" scoped>
.redirect-page {
    display: flex;
    align-items: center;
    justify-content: center;
    >span {
        display: inline-block;
        margin-top: 20px;
    }
}
</style>